<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">회원관리</span>
            <span class="txt">
                센터에 등록한 회원님을 검색하실 수 있으며, 회원님의 성함을 눌러 이용권 등록 및 마일리지 등록 등 회원님의
                다양한 설정을 진행하실 수 있습니다.
            </span>
        </div>
        <loading-spinner v-if="isLoading"></loading-spinner>
        <template v-else>
            <div style="display: flex; gap: 28px">
                <div class="photo-info-card">
                    <img
                        class="photo"
                        :src="customerInfo.imageUrl ? customerInfo.imageUrl : '/img/icons/no_photo.jpg'"
                        alt="사진"
                    />
                    <div class="info-txt">
                        <span class="txt name" v-if='customerInfo.name'>{{ customerInfo.name + ` (${customerInfo.attendNo})` }}</span>
                        <span class="txt" v-if='customerInfo.phone'>{{ customerInfo.phone | phoneNumberFilter }}</span>
                        <span class="txt" v-if='customerInfo.name'>{{ convertTeamGroupsToString(customerInfo.centerCustomerTeamGroups) }}</span>
                        <span v-if="customerInfo.centerLocker" class="txt">
                            {{ customerInfo.centerLocker.lockerGroupName }} {{ customerInfo.centerLocker.lockerNo }}번
                        </span>
                        <span v-else="customerInfo.centerLocker" class="txt">-</span>
                    </div>
                    <span v-if="customerInfo.status === 'V'" class="icon green">유효</span>
                    <span v-if="customerInfo.status === 'E'" class="icon red">만료</span>
                    <span v-if="customerInfo.status === '-'" class="icon gray">잠재</span>
                    <span v-if="customerInfo.status === 'H'" class="icon yellow">홀딩</span>
                    <!--<button class="send-btn">인증코드전송</button>-->
                </div>
                <div class="d-flex flex-column" style="margin-top: 35px">
                    <button
                        v-if="hasMessageEvent && customerInfo.mktAgreeSms"
                        class="com-btn white"
                        @click="routing('messageSend', customerInfo)"
                    >
                        메시지 발송
                    </button>
                    <button
                        v-show="isAllowed('ME', 6)"
                        class="com-btn white"
                        style="margin-top: 10px"
                        @click="showContractSendPopup()"
                    >
                        계약서 발송
                    </button>
                    <button
                        v-if="showPaymentLinkBtn"
                        style="margin-top: 10px"
                        class="com-btn deep-blue"
                        @click="togglePayLinkPop(true)"
                    >
                        결제링크전송
                    </button>
                </div>

                <div class="info-card">
                    <div class="info-txt">
                        <span class="txt name">최근 수업일</span>
                        <span class="txt">{{ lastLessonDaysAgo }}일전</span>
                        <span class="txt">마지막 출석: {{ customerInfo.latestLessonAt | dateFormatFilter }}</span>
                    </div>
                </div>
            </div>
            <div class="com-tab">
                <button @click="onClickRouter('/madmin/member/info')">기본정보</button>
                <button class="on">결제내역</button>
                <button @click="onClickRouter('/madmin/member/cancel')">예약/취소내역</button>
                <button @click="onClickRouter('/madmin/member/attend')">입장/출결내역</button>
                <button @click="onClickRouter('/madmin/member/mileage')">마일리지</button>
                <button
                    @click="
                        checkAllowedClick('MB', 3, () => {
                            onClickRouter('/madmin/member/advice');
                        })
                    "
                >
                    상담내역
                </button>
                <button @click="onClickRouter('/madmin/member/message')">메시지발송내역</button>
                <button v-show='isAllowed("ME", 7)' @click="onClickRouter('/madmin/member/contract_send')">계약서발송내역</button>
            </div>

            <div class="com-table-content">
                <div class="com-btn-area">
                    <div class="left-box">
                        <span class="tit">이용권 결제 내역</span>
                    </div>
                    <div class="right-box">
                        <button
                            class="com-btn blue"
                            @click="
                                checkAllowedClick('LE', 1, () => {
                                    $router.push({ path: `/madmin/member/account/${centerId}`, query: { customerId } });
                                })
                            "
                        >
                            이용권 결제
                        </button>
                    </div>
                </div>
                <table class="com-table">
                    <colgroup>
                        <col style="width: 430px" />
                        <col style="width: 245px" />
                        <col style="width: 285px" />
                        <col style="width: 155px" />
                        <col style="width: 155px" v-if="isAllowed('SA', 6)" />
                        <col style="width: 155px" />
                        <col style="width: 170px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>
                                <button @click="onClickProdNm">이용권명</button>
                            </th>
                            <th>
                                <button @click="onClickExpStartDt">유효기간</button>
                            </th>
                            <th>이용권현황</th>
                            <th>
                                <button @click="onClickLessStaffName">담당강사</button>
                            </th>
                            <th v-if="isAllowed('SA', 6)">
                                <button @click="onClickTotalBuyPrice">결제정보</button>
                            </th>
                            <th>
                                <button @click="onClickCreDt">등록일</button>
                            </th>
                            <th>계약서발송</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(t, index) in ticketBills" :key="index">
                            <td class="left">
                                <router-link
                                    :to="{
                                        path: `/madmin/member/account/${centerId}`,
                                        query: {
                                            customerId,
                                            contractId: t.cc_center_contract_id,
                                            allowedCount: t.resv_total_cnt,
                                        },
                                    }"
                                    class="link"
                                >
                                    {{
                                        t.cc_ticket_type_cd === null
                                            ? '[패키지]'
                                            : convertTicketTypeFormat(t.cp_ticket_type_cd)
                                    }}
                                    {{ t.ccp_prod_nm }} {{ getLessonCntString(t.cc_less_cnt_type_cd, t.cc_less_cnt) }}
                                </router-link>
                            </td>
                            <td>
                                <span v-if="t.cc_prod_type_cd === 'T'" class="info-line">
                                    <!-- 유효기간 : 이용권일때만 보여줌 -->
                                    <span>
                                        {{ t.cc_exp_start_dt | timestampFilter }} ~
                                        {{ t.cc_exp_end_dt | timestampFilter }}
                                    </span>
                                    <span v-if="t.cc_diff_day >= 8" class="under black">
                                        {{ t.cc_diff_day }}일 남음
                                    </span>
                                    <span v-else-if="7 >= t.cc_diff_day && t.cc_diff_day > 0" class="under red">
                                        만료 {{ t.cc_diff_day }}일 전
                                    </span>
                                    <span v-else-if="t.cc_diff_day === 0" class="under red">당일만료</span>
                                    <span v-else-if="t.cc_diff_day < 0" class="under red">기간만료</span>
                                    <!--                                <span class="under">{{ calculateRemainDays(t.cc_exp_end_dt) }}</span>-->
                                </span>
                            </td>
                            <td>
                                <span v-if="t.cc_prod_type_cd === 'T'" class="info-line">
                                    <!-- 이용권 현황 : 이용권일때만 보여줌 -->
                                    <span v-if="t.cc_less_cnt_type_cd === 'U' && t.cp_ticket_type_cd === 'T'">
                                        <!--무제한인 경우-->
                                        <span class="red">{{ t.attendance_cnt == null ? 0 : t.attendance_cnt }}</span>
                                        /무제한
                                    </span>
                                    <span v-if="t.cc_less_cnt_type_cd === 'U' && t.cp_ticket_type_cd !== 'T'">
                                        <!--무제한인 경우-->
                                        <span class="red">{{ t.resv_total_cnt == null ? '0' : t.resv_total_cnt }}</span>
                                        /무제한 (출석
                                        <span class="red">
                                            {{ t.cc_less_join_cnt === null ? '0' : t.cc_less_join_cnt }}
                                        </span>
                                        / 결석
                                        <span class="red">
                                            {{ t.cc_less_absn_cnt === null ? '0' : t.cc_less_absn_cnt }}
                                        </span>
                                        )
                                    </span>
                                    <span v-if="t.cc_less_cnt_type_cd === 'T'">
                                        <!-- 총 횟수인 경우-->
                                        총
                                        <span class="red">{{ t.resv_total_cnt == null ? 0 : t.resv_total_cnt }}</span>
                                        /{{ t.cc_less_cnt }} 회 (출석
                                        <span class="red">
                                            {{ t.cc_less_join_cnt === null ? '0' : t.cc_less_join_cnt }}
                                        </span>
                                        / 결석
                                        <span class="red">
                                            {{ t.cc_less_absn_cnt === null ? '0' : t.cc_less_absn_cnt }}
                                        </span>
                                        )
                                    </span>
                                    <span v-if="t.cc_less_cnt_type_cd === 'W'">
                                        <!-- 주당 횟수인 경우-->
                                        <span class="red">{{ t.resv_total_cnt == null ? 0 : t.resv_total_cnt }}</span>
                                        /주 {{ t.cc_less_cnt }} 회 (출석
                                        <span class="red">
                                            {{ t.cc_less_join_cnt === null ? '0' : t.cc_less_join_cnt }}
                                        </span>
                                        / 결석
                                        <span class="red">
                                            {{ t.cc_less_absn_cnt === null ? '0' : t.cc_less_absn_cnt }}
                                        </span>
                                        )
                                    </span>
                                    <!-- <span v-else><span class="red">{{ t.cc_less_join_cnt + t.cc_less_absn_cnt }}</span>/{{ t.cc_less_cnt }} 회 (출석 <span class="red">{{ t.cc_less_join_cnt === null? '0' : t.cc_less_join_cnt }}</span> / 결석 <span class="red">{{ t.cc_less_absn_cnt === null ? '0' : t.cc_less_absn_cnt }}</span>)</span> -->
                                    <span v-if="t.cc_ticket_type_cd !== 'T'" class="center">
                                        <span v-if="t.cp_ticket_type_cd === 'T'">
                                            <router-link
                                                :to="{
                                                    path: `/madmin/member/attend/${centerId}`,
                                                    query: { customerId: t.cc_center_cust_id },
                                                }"
                                                class="com-btn-small deep-black"
                                            >
                                                스케줄 &gt;
                                            </router-link>
                                        </span>
                                        <span v-else>
                                            <!--그 외-->
                                            <router-link
                                                :to="{
                                                    path: `/madmin/course/care/reserve`,
                                                    query: {
                                                        customerId: t.cc_center_cust_id,
                                                        contractId: t.cc_center_contract_id,
                                                        centerProductId: t.cp_center_prod_id,
                                                    },
                                                }"
                                                class="com-btn-small deep-black"
                                            >
                                                스케줄 &gt;
                                            </router-link>
                                        </span>
                                        <!-- <a href="#" class="com-btn-small deep-black">스케줄 &gt;</a> -->
                                    </span>
                                </span>
                            </td>
                            <td>{{ t.cc_staff_name }}</td>
                            <td v-if="isAllowed('SA', 6)">
                                <span class="info-line">
                                    <span v-if="t.cc_ret_yn" class="under red">환불완료</span>
                                    <span
                                        v-for="(bill, index) in t.billInfoArray"
                                        v-if="!t.cc_ret_yn"
                                        :key="index"
                                        class="blue"
                                    >
                                        {{ bill }}
                                    </span>
                                    <span class="blue">
                                        {{ convertPayType(t.ccb_pay_type_cd) }}
                                        {{ t.ccb_bill_price | numberFormatFilter }}
                                    </span>
                                    <span class="red" v-if="t.cc_total_debt_price !== 0">
                                        [미수금] {{ t.cc_total_debt_price | numberFormatFilter }} 원
                                    </span>
                                </span>
                            </td>
                            <td>{{ t.cc_cre_dt | timestampFilter }}</td>
                            <td>{{ t.ticket_used_count > 0 ? '발송완료' : '발송안함' }}</td>
                        </tr>
                        <tr v-if="ticketBills.length === 0">
                            <td colspan="100">등록된 내용이 없습니다.</td>
                        </tr>
                    </tbody>
                </table>
                <b-pagination
                    v-model="ticketBillsPagingInfo.page"
                    :per-page="ticketBillsPagingInfo.limit"
                    :total-rows="ticketBillsPagingInfo.totalItems"
                    align="center"
                    aria-controls="my-table"
                    first-class="first"
                    last-class="last"
                    next-class="next"
                    prev-class="prev"
                    @change="handlerPagenation($event, 'ticketBills')"
                ></b-pagination>
            </div>

            <div class="com-table-content">
                <div class="com-btn-area">
                    <div class="left-box">
                        <span class="tit">락커 결제 내역</span>
                    </div>
                    <div class="right-box">
                        <button
                            class="com-btn blue"
                            @click="
                                checkAllowedClick('MB', 6, () => {
                                    $router.push({ path: '/madmin/member/locker' });
                                })
                            "
                        >
                            락커 결제
                        </button>
                    </div>
                </div>
                <table class="com-table">
                    <colgroup>
                        <col style="width: 310px" />
                        <col style="width: 150px" />
                        <col style="width: 170px" />
                        <col style="width: 330px" />
                        <col style="width: 155px" />
                        <col style="width: 155px" />
                        <col style="width: 155px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>
                                <button @click="onClickLockerGroupNm">락커명</button>
                            </th>
                            <th>락커번호</th>
                            <th>결제일자</th>
                            <th>
                                <button @click="onClickLockerRentStartDt">유효기간</button>
                            </th>
                            <th>
                                <button @click="onClickLockerTotalBuyPrice">결제정보</button>
                            </th>
                            <th>
                                <button @click="onClickLockerStatus">상태</button>
                            </th>
                            <th>관리</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(l, index) in lockerBills" :key="index">
                            <td>{{ l.cc_locker_group_nm }}</td>
                            <td>{{ l.cc_locker_no }}</td>
                            <td>{{ l.cc_buy_dt | timestampFilter }}</td>
                            <td>
                                <span class="blue">
                                    {{ l.ccp_exp_start_dt | timestampFilter }} ~
                                    {{ l.ccp_exp_end_dt | timestampFilter }}
                                </span>
                            </td>
                            <td>
                                {{ l.ccp_locker_rent_month ? l.ccp_locker_rent_month : 1 }}개월
                                {{ (l.cc_bill_info ? l.cc_bill_info : "_").split("_")[1] | numberFormatFilter }}원
                            </td>
                            <td>
                                <span :class="classLockerStatus(l)">
                                    {{ getLockerStatus(l) }}
                                    <span v-if="l.ccp_locker_ret_dt">
                                        <br />
                                        {{ l.ccp_locker_ret_dt | dateFormatFilter }}
                                    </span>
                                </span>
                            </td>
                            <td>
                                <button
                                    v-if="getLockerStatus(l) === '사용중' || getLockerStatus(l) === '종료'"
                                    class="com-btn"
                                    @click="
                                        checkAllowedClick('MB', 6, () => {
                                            onClickLockerDelete(l.cc_center_id, l.ccp_center_prod_id, l.cc_locker_no);
                                        })
                                    "
                                >
                                    회수
                                </button>
                            </td>
                        </tr>
                        <tr v-if="lockerBills.length === 0">
                            <td colspan="100">등록된 내용이 없습니다.</td>
                        </tr>
                    </tbody>
                </table>
                <b-pagination
                    v-model="lockerBillsPagingInfo.page"
                    :per-page="lockerBillsPagingInfo.limit"
                    :total-rows="lockerBillsPagingInfo.totalItems"
                    align="center"
                    aria-controls="my-table"
                    first-class="first"
                    last-class="last"
                    next-class="next"
                    prev-class="prev"
                    @change="handlerPagenation($event, 'lockerBills')"
                ></b-pagination>
            </div>

            <!-- 락커회수 삭제 팝업 -->
            <div v-if="lockerDelPop && selectedLockerDetail" class="layer-pop square-type">
                <div class="view-content w655">
                    <button class="close" @click="onClickCloseLockerDelPop">
                        <span class="blind">팝업 닫기</span>
                    </button>
                    <loading-spinner v-if="lockerDelPopIsLoading"></loading-spinner>
                    <div v-else class="scroll-area com-scroll-y">
                        <span class="sub-title">
                            락커회수
                            <span class="info-txt">{{ selectedLockerDetail.lockerNo }}번</span>
                        </span>
                        <p class="sub-txt">사용 중인 락커를 삭제 하시겠습니까?</p>
                        <table class="com-table left no-border">
                            <colgroup>
                                <col style="width: 135px" />
                                <col style="width: 465px" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>센터</th>
                                    <td>{{ centerInfo.centerName }}</td>
                                </tr>
                                <tr>
                                    <th>락커구분</th>
                                    <td>{{ selectedLockerDetail.lockerGroupName }}</td>
                                </tr>
                                <tr>
                                    <th>성별</th>
                                    <td>{{ convertLockerSex(selectedLockerDetail.sex) }}</td>
                                </tr>
                                <tr>
                                    <th>락커번호</th>
                                    <td>{{ selectedLockerDetail.lockerNo }}</td>
                                </tr>
                                <tr>
                                    <th>회원명</th>
                                    <td>{{ selectedLockerDetail.rentCustomerName }}</td>
                                </tr>
                                <tr>
                                    <th>대여기간</th>
                                    <td>
                                        <div class="com-calendar-wrap">
                                            <single-calendar
                                                :start-date="selectedLockerDetail.rentStartedAt"
                                                class="w150"
                                                disabled
                                            ></single-calendar>
                                            <div class="com-dash"><span class="dash">~</span></div>
                                            <single-calendar
                                                :end-date="selectedLockerDetail.rentEndedAt"
                                                class="w150"
                                                disabled
                                            ></single-calendar>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>금액</th>
                                    <td>
                                        {{ selectedLockerDetail.rentMonth }}개월 -
                                        {{ selectedLockerDetail.rentBillPrice | numberFormatFilter }}원
                                    </td>
                                </tr>
                                <tr>
                                    <th><span class="red">회수날짜</span></th>
                                    <td>
                                        <single-calendar
                                            :date="this.today"
                                            :disabled="true"
                                            class="w150"
                                        ></single-calendar>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="bottom-btn">
                            <button class="com-btn" @click="onClickCloseLockerDelPop">취소</button>
                            <button
                                class="com-btn blue"
                                @click="
                                    onClickLockerExtend(
                                        selectedLockerDetail.lockerNo,
                                        selectedLockerDetail.rentCustomerId,
                                        selectedLockerDetail.centerProductId
                                    )
                                "
                            >
                                연장
                            </button>
                            <button class="com-btn blue" @click="onClickLockerReturn">회수</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="com-table-content">
                <div class="com-btn-area">
                    <div class="left-box">
                        <span class="tit">판매등록</span>
                    </div>
                    <div class="right-box">
                        <router-link :to="{ path: `/madmin/sales/sell/edit` }" class="com-btn blue">
                            판매 등록
                        </router-link>
                    </div>
                </div>
                <table class="com-table">
                    <colgroup>
                        <col style="width: 480px" />
                        <col style="width: 155px" />
                        <col style="width: 500px" />
                        <col style="width: 145px" />
                        <col style="width: 145px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>
                                <button @click="onClickSubProdNm">항목</button>
                            </th>
                            <th>
                                <button @click="onClickSubProdPrice">금액</button>
                            </th>
                            <th>메모</th>
                            <th>
                                <button @click="onClickSubProdStaffNm">판매자</button>
                            </th>
                            <th>
                                <button @click="onClickSubProdCreDt">등록일자</button>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(s, index) in subProductBills" :key="index">
                            <td>{{ s.cc_prod_nm }}</td>
                            <td>{{ s.cc_total_buy_price | numberFormatFilter }}원</td>
                            <td>{{ s.cc_memo }}</td>
                            <td>{{ s.cc_sale_staff_name }}</td>
                            <td>{{ s.cc_buy_dt | timestampFilter }}</td>
                        </tr>
                        <tr v-if="subProductBills.length === 0">
                            <td colspan="100">등록된 내용이 없습니다.</td>
                        </tr>
                    </tbody>
                </table>
                <b-pagination
                    v-model="subProductBillsPagingInfo.page"
                    :per-page="subProductBillsPagingInfo.limit"
                    :total-rows="subProductBillsPagingInfo.totalItems"
                    align="center"
                    aria-controls="my-table"
                    first-class="first"
                    last-class="last"
                    next-class="next"
                    prev-class="prev"
                    @change="handlerPagenation($event, 'subProductBills')"
                ></b-pagination>
            </div>

            <payment-link-dlg
                :customerId="customerId"
                :show="payLinkPop"
                :close="() => togglePayLinkPop(false)"
                :change="() => fetchTicketBills()"
            ></payment-link-dlg>
        </template>
        <contract-send-dlg
            v-if="contractSendPop"
            :show="contractSendPop"
            :info="contractSendInfo"
            :close="handleCloseContractSend"
            :charge="handleCharge"
            :paymentLinkSend="handlePaymentLinkSend"
        ></contract-send-dlg>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import moment from 'moment';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import { Utils } from '@/assets/js/utils';
import { pagingInfo } from '@/assets/js/common';
import PaymentLinkDlg from '@/components/PaymentLinkDlg';
import ContractSendDlg from '../../../components/ContractSendDlg';

export default {
    name: 'memberPayment',
    mixins: [MixinAllowedMenu],
    components: {
        PaymentLinkDlg,
        ContractSendDlg,
    },
    props: {},
    computed: {
        today() {
            return moment().format('YYYY-MM-DD');
        },
        showPaymentLinkBtn() {
            return this.isAllowed('LE', 1);
        },

        lastLessonDaysAgo() {
            if (this.customerInfo.latestLessonAt) {
                return moment().startOf('day').diff(moment(this.customerInfo.latestLessonAt).startOf('day'), 'days');
            }

            return '-';
        }
    },
    async mounted() {
        await this.allowedMenuEvent.init();
        await this.init();
    },
    data() {
        return {
            hasMessageEvent: false, // 메시지 계약되었을시..
            isLoading: false,
            centerId: this.$route.params.id,
            customerId: this.$route.query.customerId,
            prevPagingStep: this.$route.query.prevPagingStep,
            customerInfo: {}, // 회원 정보
            ticketBills: [], // 이용권 결제 목록
            lockerBills: [], // 락커 결제 목록
            subProductBills: [], // 부가상품 결제 목록
            ticketBillsPagingInfo: { ...pagingInfo }, // 이용권 결제 목록 페이징 파라미터
            lockerBillsPagingInfo: { ...pagingInfo }, // 락커 결제 목록 페이징 파라미터
            subProductBillsPagingInfo: { ...pagingInfo }, // 부가상품 결제 목록 페이징 파라미터

            ticketSortType: 'DESC', // 이용권 결제 목록 정렬방법 (오름차순 : ASC, 내림차순 : DESC)
            ticketSortColumn: '', // 이용권 결제 목록 정렬컬럼 (이용권명 : cc_prod_nm, 유효기간 : cc_exp_start_dt, 담당강사명 : cc_less_staff_name, 결제금액 : cc_total_buy_price, 등록일 : cc_cre_dt)

            lockerSortType: 'DESC', // 락커 결제 목록 정렬방법 (오름차순 : ASC, 내림차순 : DESC)
            lockerSortColumn: '', // 락커 결제 목록 정렬컬럼 (락커명 : cc_locker_group_nm, 유효기간 : cc_rent_start_dt, 결제금액 : cc_total_buy_price, 상태 : cc_locker_status)

            subProductSortType: 'DESC', // 부가상품 결제 목록 정렬방법 (오름차순 : ASC, 내림차순 : DESC)
            subProductSortColumn: '', // 부가상품 결제 목록 정렬컬럼 (상품명 : cc_prod_nm, 결제금액 : cc_total_buy_price, 판매자 : cc_sale_staff_name, 등록일 : cc_cre_dt)
            // 락커회수 관련
            selectedLockerDetail: {
                rentReturnedAt: this.today,
            },
            lockerDelPop: false,
            payLinkPop: false,
            centerInfo: {},
            staffId: '',

            contractSendPop: false,
            contractSendInfo: {},
        };
    },
    methods: {
        routing(toName, checkedUserData) {
            const routingData = [];
            // checkedUserData.forEach((param) => {
            const tempValue = {
                ...checkedUserData,
            };
            routingData.push(tempValue);
            // });
            this.$router.push({
                name: toName,
                params: { data: routingData },
            });
        },

        checkMessageEvent() {
            return api
                .get('/admin/api/center/ftcontract/sms')
                .then((res) => {
                    this.hasMessageEvent = JSON.parse(res.data);
                })
                .catch((error) => {
                    this.hasMessageEvent = false;
                });
        },

        // 초기화
        async init() {
            this.ticketBillsPagingInfo.page = 1;
            this.lockerBillsPagingInfo.page = 1;
            this.subProductBillsPagingInfo.page = 1;
            this.isLoading = true;
            this.staffId = parseInt(this.$store.getters['auth/staffId']);

            Promise.allSettled([
                this.fetchCustomerDetail(), // 회원 정보 가져오기
                this.fetchTicketBills(), // 이용권 결제 목록 가져오기
                this.fetchLockerBills(), // 락커 결제 목록 가져오기
                this.fetchSubProductBills(), // 부가상품 결제 목록 가져오기
                this.getCenterInfo(),
            ]); // 로그인한 센터 정보 가져오기
            this.isLoading = false;

            this.checkMessageEvent();
        },

        // 회원 정보 가져오기
        async fetchCustomerDetail() {
            try {
                const { data } = await this.sendGetCustomerDetail();
                this.customerInfo = data;
                this.customerInfo.centerCustomerTeamGroups = this.customerInfo.centerCustomerTeamGroups.filter(
                    (g) => !g.centerCustomerTeam.info.deleteYn
                );
                for (let i in this.customerInfo.centerLockers) {
                    if (this.customerInfo.centerLockers[i].lockerStatus !== 'F') {
                        this.customerInfo.centerLocker = this.customerInfo.centerLockers[i];
                        break;
                    }
                }
            } catch (error) {
                alert('회원정보를 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 회원 기본정보 조회 API 호출
        sendGetCustomerDetail() {
            return api.get(`/admin/api/center/${this.centerId}/customer/${this.customerId}`);
        },

        // 이용권 결제 목록 가져오기
        async fetchTicketBills() {
            try {
                const { data } = await this.sendGetTicketBills();
                this.ticketBills = data.items;
                this.ticketBills.forEach((t) => {
                    t.billInfoArray = this.convertBillInfo(t.cc_bill_info);
                });

                this.setPageParams(data, 'ticket');

                /*
                this.ticketBillsPagingInfo.totalPages = data.meta.totalPages;
                this.ticketBillsPagingInfo.page = data.meta.currentPage;
                this.ticketBillsPagingInfo.totalItems = data.meta.totalItems;
                this.ticketBillsPagingInfo.itemCount = data.meta.itemCount;
                */
            } catch (error) {
                alert('이용권 결제 목록을 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 이용권 결제 목록 API 호출
        sendGetTicketBills() {
            const params = {
                productType: 'T',
                sortType: this.ticketSortType, // 정렬방법 (오름차순 : ASC, 내림차순 : DESC)
                sortColumn: this.ticketSortColumn, // 정렬컬럼
            };
            // 스웨거 검색: 센터회원계약 이용권 결제 목록 조회/매출현황(상품)
            // return api.get(`/admin/api/center/${this.centerId}/customer/${this.customerId}/contract/bill/ticket`, {
            //     params: {
            //         ...this.ticketBillsPagingInfo,
            //         ...params
            //     }
            // });
            // 모든 이용권의 예약 권한 적용(SC_EVENT_007)
            let centerStaffId = null;
            if (this.allowedMenuEvent.eventCds != null && !this.allowedMenuEvent.eventCds.includes('SC_EVENT_007')) {
                centerStaffId = this.staffId;
            }
            return api.get(`/admin/api/center/${this.centerId}/lesson`, {
                params: {
                    ...this.ticketBillsPagingInfo,
                    productType: 'T',
                    centerCustomerId: this.customerId,
                    centerStaffId,
                },
            });
        },

        // 락커 결제 목록 가져오기
        async fetchLockerBills() {
            try {
                const { data } = await this.sendGetLockerBills();
                this.lockerBills = data.items;
                this.setPageParams(data, 'locker');
            } catch (error) {
                alert('락커 결제 목록을 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 락커 결제 목록 API 호출
        sendGetLockerBills() {
            const params = {
                sortType: this.lockerSortType, // 정렬방법 (오름차순 : ASC, 내림차순 : DESC)
                sortColumn: this.lockerSortColumn, // 정렬컬럼
            };
            return api.get(`/admin/api/center/${this.centerId}/customer/${this.customerId}/contract/bill/locker`, {
                params: {
                    ...this.lockerBillsPagingInfo,
                    ...params,
                },
            });
        },

        // 부가상품 결제 목록 가져오기
        async fetchSubProductBills() {
            try {
                const { data } = await this.sendGetSubProductBills();
                this.setPageParams(data, 'subProduct');
                this.subProductBills = data.items;
            } catch (error) {
                alert('부가상품 결제 목록을 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 부가상품 결제 목록 API 호출
        sendGetSubProductBills() {
            const params = {
                sortType: this.subProductSortType, // 정렬방법 (오름차순 : ASC, 내림차순 : DESC)
                sortColumn: this.subProductSortColumn, // 정렬컬럼
            };

            // 스웨거 검색: 센터회원계약 부가상품 결제 목록 조회
            return api.get(`/admin/api/center/${this.centerId}/customer/${this.customerId}/contract/bill/sub-product`, {
                params: {
                    ...this.subProductBillsPagingInfo,
                    ...params,
                },
            });
        },

        // 페이지 이동
        onClickRouter(path) {
            this.$router.push({
                path: `${path}/${this.centerId}`,
                query: {
                    customerId: this.customerId,
                    prevPagingStep: this.prevPagingStep,
                },
            });
        },

        // 페이지 변경 Handler
        handlerPagenation(event, pagingType) {
            if (pagingType === 'ticketBills') {
                this.ticketBillsPagingInfo.page = event;
                this.fetchTicketBills();
            } else if (pagingType === 'lockerBills') {
                this.lockerBillsPagingInfo.page = event;
                this.fetchLockerBills();
            } else if (pagingType === 'subProductBills') {
                this.subProductBillsPagingInfo.page = event;
                this.fetchSubProductBills();
            }
        },

        // 이용권 코드 변환
        convertTicketTypeFormat(type) {
            if (type === 'P') {
                return '[개인]';
            } else if (type === 'O') {
                return '[OT]';
            } else if (type === 'D') {
                return '[듀엣]';
            } else if (type === 'G') {
                return '[그룹]';
            } else if (type === 'C') {
                return '[쿠폰]';
            } else if (type === 'T') {
                return '[회원권]';
            } else if (type === 'S') {
                return '[운동복]';
            }
            return '[None]';
        },
        // 남은 일수 계산
        calculateRemainDays(expireDate) {
            const ed = moment(this.timestampFilter(expireDate), 'YYYY-MM-DD');
            const currentDate = moment().startOf('day');
            const remainDays = moment.duration(ed.diff(currentDate)).asDays();
            return remainDays >= 0 ? `${remainDays}일 남음` : '';
        },

        // timestampTZ -> date (년-월-일)
        timestampFilter(value) {
            const b = value.split(/\D/);
            b[1] -= 1;
            b[6] = b[6].substr(0, 3);
            const d = new Date(Date.UTC(...b));
            return `${d.getFullYear()}-${this.addZero(d.getMonth() + 1)}-${this.addZero(d.getDate())}`;
        },

        addZero(target) {
            // 9 이하의 숫자는 0 붙이기
            const num = parseInt(target);
            const str = num > 9 ? num : `0${num}`;
            return str.toString();
        },

        // 회원 정보 카드에 나타낼 회원 그룹 이름 만들기
        convertTeamGroupsToString(teamGroups) {
            if (teamGroups === undefined) {
                return '';
            }
            if (teamGroups.length === 1) {
                // 그룹이 1개일 경우
                return teamGroups[0].centerCustomerTeamName;
            } else if (teamGroups.length === 0) {
                // 그룹이 없을 경우
                return '-';
            } else if (teamGroups.length > 1) {
                // 그룹이 여러개일 경우
                return `${teamGroups[0].centerCustomerTeamName} 외 ${teamGroups.length - 1}`;
            }
            return '';
        },

        // 결제수단_금액 가공
        convertBillInfo(billInfo) {
            // ex) C_1300000|L_240000 결제수단_금액 으로 들어오는 string 값을 가공
            const result = '-';
            const billInfoArray = [];
            if (billInfo === undefined) {
                // undeifiend인 경우
                return;
            }
            if (billInfo !== null) {
                const temp1 = billInfo.split('|');
                temp1.forEach((bill) => {
                    const temp2 = bill.split('_');
                    let payType = '';
                    switch (temp2[0]) {
                        case 'C':
                            payType = '[카드]';
                            break;
                        case 'L':
                            payType = '[현금]';
                            break;
                        case 'B':
                            payType = '[계좌이체]';
                            break;
                        case 'M':
                            payType = '[마일리지]';
                            break;
                        case 'E':
                            payType = '[기타]';
                            break;
                        case 'T':
                            payType = '[핏페이]';
                            break;
                        case 'U':
                            payType = '[핏페이]';
                            break;
                        case 'K':
                            payType = '[키오스크]';
                            break;
                        default:
                            payType = '[-]';
                    }
                    const result = `${payType} ${this.getNumberFormat(parseInt(temp2[1]))}원`; // ex) [카드] 240,000원 으로 만듦
                    billInfoArray.push(result);
                });
                return billInfoArray;
            }
            billInfoArray.push(result);
            return billInfoArray;
        },

        // 금액에 , 넣기
        getNumberFormat(num) {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        // 락커 상태 변환
        convertLockerStatus(item) {
            if (this.getLockerStatus(item) === '회수완료') {
                return `회수완료${moment(item.ccp_locker_ret_dt).format('YYYY-MM-DD')}`;
            }
            return '';
        },
        // 락커 상태 클래스
        classLockerStatus(item) {
            if (this.getLockerStatus(item) === '사용중') {
                return ['green'];
            }
            return ['red'];
        },
        getLockerStatus(item) {
            if (item.ccp_locker_ret_dt) {
                return '회수완료';
            }

            if (item.cc_rent_end_dt && moment().isAfter(item.cc_rent_end_dt)) {
                return '종료';
            }

            if (!item.valid_contract_id) return '연장';

            return '사용중';
        },
        // 페이징 Param 설정
        setPageParams(data, pagingType) {
            let pInfo = null;
            if (pagingType === 'ticket') {
                pInfo = this.ticketBillsPagingInfo;
            } else if (pagingType === 'locker') {
                pInfo = this.lockerBillsPagingInfo;
            } else if (pagingType === 'subProduct') {
                pInfo = this.subProductBillsPagingInfo;
            }

            if (pInfo != null) {
                pInfo.totalPages = data.meta.totalPages;
                pInfo.page = data.meta.currentPage;
                pInfo.totalItems = data.meta.totalItems;
                pInfo.itemCount = data.meta.itemCount;
            }
        },

        // 이용권명 컬럼 클릭시
        onClickProdNm() {
            this.ticketSortColumn = 'cc_prod_nm';
            if (this.ticketSortType === '' || this.ticketSortType === 'DESC') {
                this.ticketSortType = 'ASC';
            } else {
                this.ticketSortType = 'DESC';
            }
            this.fetchTicketBills();
        },

        // 유효기간 컬럼 클릭시
        onClickExpStartDt() {
            this.ticketSortColumn = 'cc_exp_start_dt';
            if (this.ticketSortType === '' || this.ticketSortType === 'DESC') {
                this.ticketSortType = 'ASC';
            } else {
                this.ticketSortType = 'DESC';
            }
            this.fetchTicketBills();
        },

        // 담당강사 컬럼 클릭시
        onClickLessStaffName() {
            this.ticketSortColumn = 'cc_less_staff_name';
            if (this.ticketSortType === '' || this.ticketSortType === 'DESC') {
                this.ticketSortType = 'ASC';
            } else {
                this.ticketSortType = 'DESC';
            }
            this.fetchTicketBills();
        },

        // 결제금액 컬럼 클릭시
        onClickTotalBuyPrice() {
            this.ticketSortColumn = 'cc_total_buy_price';
            if (this.ticketSortType === '' || this.ticketSortType === 'DESC') {
                this.ticketSortType = 'ASC';
            } else {
                this.ticketSortType = 'DESC';
            }
            this.fetchTicketBills();
        },

        // 등록일 컬럼 클릭시
        onClickCreDt() {
            this.ticketSortColumn = 'cc_cre_dt';
            if (this.ticketSortType === '' || this.ticketSortType === 'DESC') {
                this.ticketSortType = 'ASC';
            } else {
                this.ticketSortType = 'DESC';
            }
            this.fetchTicketBills();
        },

        // 락커명 컬럼 클릭시
        onClickLockerGroupNm() {
            this.lockerSortColumn = 'cc_locker_group_nm';
            if (this.lockerSortType === '' || this.lockerSortType === 'DESC') {
                this.lockerSortType = 'ASC';
            } else {
                this.lockerSortType = 'DESC';
            }
            this.fetchLockerBills();
        },

        // 유효기간 컬럼 클릭시
        onClickLockerRentStartDt() {
            this.lockerSortColumn = 'cc_rent_start_dt';
            if (this.lockerSortType === '' || this.lockerSortType === 'DESC') {
                this.lockerSortType = 'ASC';
            } else {
                this.lockerSortType = 'DESC';
            }
            this.fetchLockerBills();
        },

        // 결제정보 컬럼 클릭시
        onClickLockerTotalBuyPrice() {
            this.lockerSortColumn = 'cc_total_buy_price';
            if (this.lockerSortType === '' || this.lockerSortType === 'DESC') {
                this.lockerSortType = 'ASC';
            } else {
                this.lockerSortType = 'DESC';
            }
            this.fetchLockerBills();
        },

        // 상태 컬럼 클릭시
        onClickLockerStatus() {
            this.lockerSortColumn = 'cc_locker_status';
            if (this.lockerSortType === '' || this.lockerSortType === 'DESC') {
                this.lockerSortType = 'ASC';
            } else {
                this.lockerSortType = 'DESC';
            }
            this.fetchLockerBills();
        },

        // 판매등록 상품명(항목) 클릭시
        onClickSubProdNm() {
            this.subProductSortColumn = 'cc_prod_nm';
            if (this.subProductSortType === '' || this.subProductSortType === 'DESC') {
                this.subProductSortType = 'ASC';
            } else {
                this.subProductSortType = 'DESC';
            }
            this.fetchSubProductBills();
        },

        // 판매등록 금액 클릭시
        onClickSubProdPrice() {
            this.subProductSortColumn = 'cc_total_buy_price';
            if (this.subProductSortType === '' || this.subProductSortType === 'DESC') {
                this.subProductSortType = 'ASC';
            } else {
                this.subProductSortType = 'DESC';
            }
            this.fetchSubProductBills();
        },

        // 판매등록 판매자 클릭시
        onClickSubProdStaffNm() {
            this.subProductSortColumn = 'cc_sale_staff_name';
            if (this.subProductSortType === '' || this.subProductSortType === 'DESC') {
                this.subProductSortType = 'ASC';
            } else {
                this.subProductSortType = 'DESC';
            }
            this.fetchSubProductBills();
        },

        // 판매등록 등록일자 클릭시
        onClickSubProdCreDt() {
            this.subProductSortColumn = 'cc_cre_dt';
            if (this.subProductSortType === '' || this.subProductSortType === 'DESC') {
                this.subProductSortType = 'ASC';
            } else {
                this.subProductSortType = 'DESC';
            }
            this.fetchSubProductBills();
        },

        // 수업 횟수 유형 변환
        getLessonCntString(lessonCountType, lessonCount) {
            let str = '';
            switch (lessonCountType) {
                case 'T': // 총횟수
                    str = `${lessonCount}회`;
                    break;
                case 'W': // 주당횟수
                    str = `주 ${lessonCount}회`;
                    break;
                case 'U': // 무제한
                    str = '';
                    break;
                default:
                    str = '';
            }
            return str;
        },
        // 락커 휴지통 버튼 클릭시
        async onClickLockerDelete(centerId, centerProductId, lockerNo) {
            await this.fetchCenterLockerDetail(centerId, centerProductId, lockerNo);

            // 회수날짜를 오늘날짜로 입력
            if (Utils.isEmpty(this.selectedLockerDetail.rentReturnedAt)) {
                this.selectedLockerDetail.rentReturnedAt = this.today;
            }

            this.lockerDelPop = true;
        },
        // 락커 삭제 팝업 닫기 버튼 클릭시
        onClickCloseLockerDelPop() {
            this.lockerDelPop = false;
            this.selectedLockerDetail = {
                rentReturnedAt: this.today,
            };
        },
        // 락커 번호로 락커 상세 정보 가져오기
        async fetchCenterLockerDetail(centerId, centerProductId, lockerNo) {
            try {
                this.lockerMovePopIsLoading = true;
                this.lockerDelPopIsLoading = true;
                const { data } = await this.sendGetCenterLockerDetail(centerId, centerProductId, lockerNo);
                this.selectedLockerDetail = data;
                this.lockerMovePopIsLoading = false;
                this.lockerDelPopIsLoading = false;
            } catch (error) {
                alert('락커 상세 정보를 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 센터 락커 상세정보 조회 API 호출
        sendGetCenterLockerDetail(centerId, centerProductId, lockerNo) {
            return api.get(`/admin/api/locker/detail/${centerId}/${centerProductId}/${lockerNo}`);
        },

        // 락커 이동 팝업에서 이동 버튼 클릭시
        async onClickLockerMoveSave() {
            if (!this.selectedLockerDetail.hasOwnProperty('newLockerNo')) {
                alert('락커번호를 선택하세요.');
                return false;
            }

            if (!confirm('락커를 이동하시겠습니까?')) {
                return false;
            }

            try {
                this.lockerMovePopIsLoading = true;
                await this.sendPutLockerMove();
                alert('락커를 이동했습니다.');
                this.lockerMovePopIsLoading = false;
                this.lockerMovePop = false;
                // await this.fetchLockerGroupDetailList(this.selectedCenterId, this.selectedCenterProductId);
            } catch (error) {
                Utils.alertResponseErrorMessge(error);
                // alert('락커 이동 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 락커 이동 API 호출
        sendPutLockerMove() {
            const params = this.getLockerMoveParams();
            return api.put('/admin/api/locker/move', {
                ...params,
            });
        },

        // 락커 이동 파라미터 가공
        getLockerMoveParams() {
            const { selectedLockerDetail } = this;
            const params = {
                centerId: selectedLockerDetail.centerId,
                centerProductId: selectedLockerDetail.centerProductId,
                curLockerNo: selectedLockerDetail.lockerNo,
                newLockerNo: selectedLockerDetail.newLockerNo,
                customerId: selectedLockerDetail.rentCustomerId,
                customerName: selectedLockerDetail.rentCustomerName,
            };
            return params;
        },
        // centerId 로 센터 정보 가져오기
        async getCenterInfo() {
            try {
                const { data } = await this.sendGetCenter();
                this.centerInfo = data;
            } catch (error) {
                console.log(error);
            }
        },

        // 센터 조회 API 호출
        sendGetCenter() {
            return api.get(`/admin/api/center/${this.centerId}`);
        },
        // 락커 성별 변환
        convertLockerSex(sex) {
            if (sex === '-') {
                return '공통';
            } else if (sex === 'M') {
                return '남성';
            } else if (sex === 'W') {
                return '여성';
            }
        },
        // 락커 회수 버튼 클릭시
        async onClickLockerReturn() {
            try {
                this.lockerDelPopIsLoading = true;
                await this.sendPutLockerReturn();
                this.init();
                alert('락커를 회수했습니다.');
                this.lockerDelPopIsLoading = false;
                this.lockerDelPop = false;
                // await this.fetchLockerGroupDetailList(this.selectedCenterId, this.selectedCenterProductId);
            } catch (error) {
                alert('락커 회수 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 락커 회수 API 호출
        sendPutLockerReturn() {
            const params = {
                centerId: this.selectedLockerDetail.centerId,
                centerProductId: this.selectedLockerDetail.centerProductId,
                curLockerNo: this.selectedLockerDetail.lockerNo,
                rentReturnedAt: this.today,
            };
            return api.put('/admin/api/locker/return', {
                ...params,
            });
        },
        // 결제정보
        convertPayType(val) {
            switch (val) {
                case 'C':
                    return '[카드]';
                case 'L':
                    return '[현금]';
                case 'B':
                    return '[계좌이체]';
                case 'M':
                    return '[마일리지]';
                case 'T':
                    return '[핏페이]';
                case 'U':
                    return '[핏페이]';
                case 'K':
                    return '[키오스크]';
                default:
                    return '';
            }
        },
        // 락커 회수 팝업에서 연장 버튼 클릭시
        async onClickLockerExtend(lockerNo, customerId, productId) {
            if (!confirm('락커를 연장하시겠습니까?')) {
                return false;
            }
            try {
                const query = {
                    customerId,
                    productId,
                };

                await this.$router.push({ path: `/madmin/member/locker/edit/${lockerNo}`, query });
            } catch (e) {
                Utils.alertResponseErrorMessge(e);
            }
            return false;
        },
        togglePayLinkPop(open) {
            if (open && !this.isAllowed('SA', 'FITPAY')) {
                if (confirm('핏페이 가입을 해야 이용할수 있는 기능입니다.\n 지금 신청하시겠습니까?.')) {
                    this.$router.push({ path: `/madmin/setting/center/${this.centerId}/fitpay` });
                }

                return;
            }
            this.payLinkPop = open;
        },

        showContractSendPopup() {
            this.contractSendInfo = {
                centerId: this.centerId,
                centerName: this.centerInfo.centerName,
                customerId: this.customerId,
                customerName: this.customerInfo.name,
                customerPhone: this.customerInfo.phone,
                templateType: 'M',
            };
            this.contractSendPop = true;
        },

        handleCloseContractSend() {
            this.contractSendPop = false;
        },

        handleCharge() {
            this.contractSendPop = false;
        },

        handlePaymentLinkSend() {
            this.contractSendPop = false;

            this.onClickRouter('/madmin/member/contract_send');
        },
    },
};
</script>
<style lang="scss"></style>
